import { useTranslation } from 'react-i18next';
import Layout from '../../components/feature/Layout';
import HeroSection from './components/HeroSection';
import AboutPreview from './components/AboutPreview';
import ServicesPreview from './components/ServicesPreview';
import PartnersPreview from './components/PartnersPreview';
import CTASection from './components/CTASection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: 'MONARU',
      alternateName: '모나루',
      url: siteUrl,
      description:
        'MONARU is the premier Korea-Vietnam bilateral brand trade agency specializing in maritime logistics, customs compliance, market entry advisory, and trade finance.',
      address: [
        {
          '@type': 'PostalAddress',
          streetAddress: '23F, POSCO Tower-Gangnam, 440 Teheran-ro',
          addressLocality: 'Gangnam-gu',
          addressRegion: 'Seoul',
          postalCode: '06211',
          addressCountry: 'KR',
        },
        {
          '@type': 'PostalAddress',
          streetAddress: 'Level 18, Bitexco Financial Tower, 2 Hai Trieu Street',
          addressLocality: 'District 1, Ho Chi Minh City',
          addressCountry: 'VN',
        },
      ],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+82-2-555-7890',
        contactType: 'customer service',
        availableLanguage: ['English', 'Korean', 'Vietnamese'],
      },
      sameAs: [],
    },
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: 'MONARU — 모나루',
      publisher: { '@id': `${siteUrl}/#organization` },
      inLanguage: 'en',
    },
  ],
};

export default function Home() {
  const { t } = useTranslation();
  return (
    <Layout>
      <title>{t('page.title.home')}</title>
      <meta
        name="description"
        content="MONARU is the premier Korea-Vietnam bilateral brand trade agency. Expert maritime logistics, customs compliance, market entry advisory, and trade finance across Seoul and Ho Chi Minh City."
      />
      <meta
        name="keywords"
        content="Korea Vietnam trade, bilateral trade agency, import export Korea Vietnam, logistics Seoul HCMC, trade compliance"
      />
      <link rel="canonical" href={`${siteUrl}/`} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <HeroSection />
      <AboutPreview />
      <ServicesPreview />
      <PartnersPreview />
      <CTASection />
    </Layout>
  );
}
